export default __webpack_public_path__ + "static/media/Rossi.1cd02440.jpg";